<template>
  <div class="container" :class="addClass" :style="styles" style="backgroundClip: content-box">
    <component-renderer v-for="field in fields" v-bind:key="field.id" :field="field" :class="field.properties.grid ? `col-lg-${field.properties.grid.columns}` : ''"/>
  </div>
</template>

<script>
import componentRenderer from "@/components/component-renderer.vue";

export default {
  name: "container",
  components: {
    componentRenderer
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    backgroundColor: {
      type: String,
      required: false
    },
    addClass: {
      type: Array,
      required:false
    },
    styles: {
      type: Object,
      required: false
    }
  }
};
</script>